import { useState, useEffect, useRef } from "react";

const FRANKFURTER_URL = "https://api.frankfurter.dev/v1/latest?base=USD&symbols=CAD,EUR,GBP";

// Module-level cache so rates are fetched once across all component instances
let cachedRates = null;

/**
 * Returns the live exchange rate for the given currency code relative to USD.
 * Fetches rates once from the Frankfurter API and caches them for the session.
 * Falls back to 1.0 on error (shows USD values as-is).
 */
const useExchangeRate = (currencyCode) => {
    const [rates, setRates] = useState(cachedRates);
    const fetchedRef = useRef(false);

    useEffect(() => {
        if (cachedRates || fetchedRef.current) return;
        fetchedRef.current = true;

        fetch(FRANKFURTER_URL)
            .then(res => res.json())
            .then(data => {
                if (data && data.rates) {
                    cachedRates = { USD: 1, ...data.rates };
                    setRates(cachedRates);
                }
            })
            .catch(() => {
                // Silently fail — rate stays 1.0
            });
    }, []);

    if (!rates || !currencyCode) return 1;
    return rates[currencyCode] || 1;
};

export default useExchangeRate;
